import React, { use, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import "./Personal.scss"
import PostService from '../../API/PostService';
import PersonalSchedule from '../../components/PersonalSchedule/PersonalSchedule/PersonalSchedule';
import { useFetching } from '../../hooks/useFetching';
import { setPersonalDataAction, setPersonalSlotsAction, setSlotsAction, setPersonalSlotsNextAction, setNextSlotsAction } from '../../store/personalScheduleReducer';
import { setCurrentScheduleAction, setConfirmed, setSpecialistsAction } from '../../store/scheduleReducer';
import { setPositionsAction } from '../../store/specialistsReducer';

const getHeaderHeight = () => {
  const headerElement = document.querySelector('.header');
  return headerElement ? headerElement.getBoundingClientRect().height : 0;
};

const Personal = () => {
    const dispatch = useDispatch();

    const currentUser = useSelector(state => state.currentUser.currentUser);
    const personalSlots = useSelector(state => state.personal.personalSlots);
    const personalSlotsNext = useSelector(state => state.personal.personalSlotsNext);
    const currentSchedule = useSelector(state => state.schedule.currentSchedule);
    const confirmed = useSelector(state => state.schedule.confirmed);

    const [nextSlots, setNextSlots] = useState(null);
    const [headerHeight, setHeaderHeight] = useState(0);
    const [pending, setPending] = useState(true);

    const getFirstDayOfMonth = (next = false) => {
        let now = new Date();
        let firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        if (next) {
            firstDay = new Date(now.getFullYear(), now.getMonth() + 1, 1);
        }
        const day = String(firstDay.getDate()).padStart(2, '0');
        const month = String(firstDay.getMonth() + 1).padStart(2, '0');
        const year = firstDay.getFullYear();

        return `${day}.${month}.${year}`;
    }

    const getMonth = (next = false) => {
        let now = new Date();
        if (next) {
            now = new Date(now.getFullYear(), now.getMonth() + 1, 1);
        }
        const month = now.toLocaleString('ru', { month: 'long' });
        const year = now.getFullYear();

        return `${month} ${year}`;
    }

    useEffect(() => {
        fetchSpecialists();
        fetchPositions();
    }, [])

    useEffect(() => {
        if (currentUser) {
            fetchUser(currentUser.fields.employee_id);
            fetchList(getFirstDayOfMonth());
            fetchNextList(getFirstDayOfMonth(true));
        }
    }, [currentUser])

    useEffect(() => {

    }, [currentSchedule, currentUser])

    const [fetchList] = useFetching(async (date) => {
        const response = await PostService.getAnyPlainMonthLists(date);

        if (response.data.result.length > 0) {
            dispatch(setCurrentScheduleAction(response.data.result[0].id));
            fetchSlots(response.data.result[0].id);
            if (response.data.result[0].draft == 0) {
                dispatch(setConfirmed(true));
            }
        } else {
            setPending(false);
            dispatch(setConfirmed(false));
        }
    })
    
    const [fetchNextList] = useFetching(async (date) => {
        const response = await PostService.getAnyPlainMonthLists(date);

        if (response.data.result.length > 0) {
            if (response.data.result[0].draft == 0) {
                fetchSlotsNext(response.data.result[0].id);
            }
        }
    })

    const [fetchUser] = useFetching(async (userId) => {
        const response = await PostService.getWorkerById(userId)
        if (response.data.success && response.data.result !== false) {
            dispatch(setPersonalDataAction(response.data.result))
        }
    })

    const [fetchSlots] = useFetching(async (scheduleId) => {
        const response = await PostService.getListItems(scheduleId);

        if (response.data.success && response.data.result !== false) {
            const slots = response.data.result[scheduleId];
            const filteredSlots = slots.filter(slot => slot.worker_id === currentUser.fields.employee_id);

            dispatch(setSlotsAction(slots));
            dispatch(setPersonalSlotsAction(filteredSlots));
            setPending(false);
        }
    })

    const [fetchSlotsNext] = useFetching(async (scheduleId) => {
        const response = await PostService.getListItems(scheduleId);

        if (response.data.success && response.data.result !== false) {
            const slots = response.data.result[scheduleId];
            const filteredSlots = slots.filter(slot => slot.worker_id === currentUser.fields.employee_id);
            
            dispatch(setNextSlotsAction(slots));
            dispatch(setPersonalSlotsNextAction(filteredSlots));
        }
    })

    const [fetchSpecialists] = useFetching(async () => {
        const response = await PostService.getWorkers()

        if (response.data.success && response.data.result !== false) {
            dispatch(setSpecialistsAction(response.data.result));
        }
    })

    const [fetchPositions] = useFetching(async () => {
        const response = await PostService.getPositions()
        if (response.data.success && response.data.result !== false) {
            dispatch(setPositionsAction(response.data.result))
        }
    })

    useEffect(() => {
        const updateHeight = () => {
            setHeaderHeight(getHeaderHeight());
        };

        updateHeight();
        window.addEventListener('resize', updateHeight);

        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return (
        <div className="personal">
            <div className="app-container--personal">
                {
                    (currentUser && currentUser.id) &&
                    <div className="personal__schedule">
                        <PersonalSchedule
                            date={getMonth()}
                            slots={personalSlots}
                            confirmed={confirmed}
                            pending={pending}
                            headerHeight={headerHeight}
                            />
                        { personalSlotsNext.length > 0 &&
                            <PersonalSchedule
                                date={getMonth(true)}
                                slots={personalSlotsNext}
                                confirmed={true}
                                pending={pending}
                                headerHeight={headerHeight}
                                nextMonth={true}
                            />
                        }
                    </div>
                }
            </div>
        </div>
    );
};

export default Personal;
